/** `Input.TextArea` wraps a native `textarea` — use on separation forms to turn off drag-to-resize. */
export const separationTextAreaClassName = "[&_textarea]:resize-none";
